module.exports = __webpack_public_path__ + "assets/img/11_794_big.96793a38.jpg";